import { forwardRef, useState } from "react"

import { Input, type InputProps } from "@coval/ui"
import { Eye, EyeOff } from "lucide-react"

interface SecretInputProps extends Omit<InputProps, "type" | "endAdornment"> {
  /** Noun used in the toggle button's aria-label, e.g. "authorization token". */
  revealLabel?: string
}

export const SecretInput = forwardRef<HTMLInputElement, SecretInputProps>(
  ({ revealLabel = "value", disabled, ...props }, ref) => {
    const [isVisible, setIsVisible] = useState(false)

    return (
      <Input
        {...props}
        ref={ref}
        type={isVisible ? "text" : "password"}
        autoComplete="new-password"
        data-lpignore="true"
        data-1p-ignore
        spellCheck={false}
        disabled={disabled}
        endAdornment={
          <button
            type="button"
            onClick={() => setIsVisible((v) => !v)}
            disabled={disabled}
            aria-label={
              isVisible ? `Hide ${revealLabel}` : `Show ${revealLabel}`
            }
            aria-pressed={isVisible}
          >
            {isVisible ? (
              <EyeOff className="h-4 w-4" />
            ) : (
              <Eye className="h-4 w-4" />
            )}
          </button>
        }
      />
    )
  },
)

SecretInput.displayName = "SecretInput"
